import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ActiveAutoplayService {
  readonly #isActive = signal(false);
  #stop: (() => void) | null = null;

  readonly isActive = this.#isActive.asReadonly();

  register(stop: () => void): void {
    this.#stop = stop;
    this.#isActive.set(true);
  }

  unregister(): void {
    this.#stop = null;
    this.#isActive.set(false);
  }

  stop(): void {
    this.#stop?.();
  }
}
